import type { CSSProperties } from 'react';
import type { DefaultTheme } from 'styled-components/macro';
import styled from 'styled-components/macro';

import ButtonIcon from 'components/ButtonIcon/ButtonIcon';

export const getOverlayStyles = (theme: DefaultTheme): Record<string, string> => ({
  backgroundColor: theme.colors.rgba.variant1,
});

export const getContentStyles = (
  theme: DefaultTheme,
  isMobile: boolean,
  overrideStyles?: CSSProperties
): Record<string, unknown> => ({
  width: 'auto',
  borderRadius: isMobile ? theme.borders.none : theme.radius.sm,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- CSSProperties needs to be spread into Record<string, unknown>
  ...((overrideStyles as any) || {}),
});

export const CloseButtonIconStyled = styled(ButtonIcon)`
  position: absolute;
  top: 24px;
  right: 16px;
  z-index: 1;
`;
